module.exports = __webpack_public_path__ + "media/images/icons/icon_arrow-text-pagetop-66e47ed4837e8dd4876d7ce6ff0044ab.png";